var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#F9FAFB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#EAECF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 19.3334H9.33333C8.59695 19.3334 8 18.7364 8 18V8.66671C8 7.93033 8.59695 7.33337 9.33333 7.33337H18.6667C19.403 7.33337 20 7.93033 20 8.66671V18C20 18.7364 19.403 19.3334 18.6667 19.3334H17.6667M14 18.6667C15.1046 18.6667 16 17.7713 16 16.6667C16 15.5621 15.1046 14.6667 14 14.6667C12.8954 14.6667 12 15.5621 12 16.6667C12 17.7713 12.8954 18.6667 14 18.6667ZM14 18.6667L14.0143 18.6666L11.8858 20.7951L10.0002 18.9095L12.0131 16.8965M14 18.6667L16.1285 20.7951L18.0142 18.9095L16.0012 16.8965M12 10H16M10.6667 12.3334H17.3333",
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobEducation);
export default __webpack_public_path__ + "static/media/job-education.f189c0f2d7f2869bea93d9fd5327bd6f.svg";
export { ForwardRef as ReactComponent };